import { TbUser } from 'react-icons/tb'
import './Avatar.sass'
import classNames from 'classnames'

function Avatar({ image, className, style = {}, size = false, ...props }) {
  return (
    <div className={classNames("avatar", className)} style={{ width: size, height: size, ...style }} {...props}>
      {image ? <img src={image} alt="avatar" /> : <TbUser className="icon" />}
    </div>
  )
}

export default Avatar